import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resource } from '../models/resource';
import { getApiUrl } from '../../main';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  private apiUrl = getApiUrl() + '/resources';

  constructor(private http: HttpClient) { }

  getResourcesBySong(songId: number): Observable<Resource[]> {
    return this.http.get<Resource[]>(`${this.apiUrl}/song/${songId}`);
  }

  getResourcesByRevel(revelId: number): Observable<Resource[]> {
    return this.http.get<Resource[]>(`${this.apiUrl}/revel/${revelId}`);
  }

  getResourcesByComposer(composerId: number): Observable<Resource[]> {
    return this.http.get<Resource[]>(`${this.apiUrl}/composer/${composerId}`);
  }

  getResourcesByType(resourceType: string): Observable<Resource[]> {
    return this.http.get<Resource[]>(`${this.apiUrl}?resourceType=${resourceType}`);
  }

  createResource(resource: Resource): Observable<Resource> {
    return this.http.post<Resource>(this.apiUrl, resource);
  }

  updateResource(id: number, resource: Resource): Observable<Resource> {
    return this.http.put<Resource>(`${this.apiUrl}/${id}`, resource);
  }

  deleteResource(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  downloadResource(path: string): Observable<Blob> {
    var downloadUrl = `${this.apiUrl}/download/${encodeURIComponent(path)}`; // Use the same base URL as other API calls
        
    return this.http.get(downloadUrl, { responseType: 'blob' });
  }

  // Get full response to access headers like Content-Disposition and Content-Type
  downloadResourceResponse(path: string): Observable<HttpResponse<Blob>> {
    const downloadUrl = `${this.apiUrl}/download/${encodeURIComponent(path)}`;
    return this.http.get(downloadUrl, { responseType: 'blob', observe: 'response' });
  }

  uploadResource(formData: FormData, resourcePath: string): Observable<void> {
    // resourcePath like 'song/anonymous/file.mid' — encode per-segment to preserve slashes
    const segments = (resourcePath || '').split('/').filter(s => s.length > 0).map(encodeURIComponent);
    const uploadUrl = `${this.apiUrl}/upload/${segments.join('/')}`;
    return this.http.post<void>(uploadUrl, formData);
  }
}